import styled from 'styled-components';

import { ButtonRoundedSmall, LabelRegular, Input } from '@comeon/ui';

export const AmountInputWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 3px;
	justify-content: center;
	width: 100%;
`;

export const RoundedButtonSecondary = styled(ButtonRoundedSmall)<{ disabled?: boolean }>`
	background: transparent;
	border: 1px solid var(--button-primary-bg, rgba(var(--primary), 1));
	color: rgba(var(--qd-modal-contrast-text), 1);
	font-size: 19px;
	margin: 0;
	min-height: 52px;
	width: 100%;
`;

export const PaymentButtonSecondary = styled(ButtonRoundedSmall)<{ disabled?: boolean }>`
	align-items: center;
	display: flex;
	font: var(--h3);
	gap: 6px;
	justify-content: center;
	margin: 0;
	min-height: 52px;
	width: 100%;
	border-radius: var(--new-qd--modal-button-rounding, 26px);

	span {
		margin: auto 6px;
	}

	svg,
	svg * {
		fill: ${({ disabled }) =>
			disabled ? `var(--button-disabled-text)` : 'var(--button-primary-text,rgba(var(--base-02),1))'};
	}

	&:disabled {
		background-color: var(--new-qd--modal-button-disabled, var(--button-disabled-bg));
		color: var(--new-qd--modal-button-text-disabled, var(--button-disabled-text));
	}
`;

export const LimitInfoText = styled.small<{ disabled?: boolean }>`
	color: ${({ disabled }) => (disabled ? 'rgba(var(--font-supportive), 1)' : 'rgba(var(--error), 1)')};
	font-size: 12px;
	font: var(--label-regular);
	line-height: 16px;
	margin-bottom: -12px;
	margin-top: 4px;
	text-align: center;
	width: 100%;
`;

export const StyledAmountInput = styled(Input)<{ hasError: boolean }>`
	background-color: var(--new-qd--amount-input-bg);
	color: var(--new-qd--amount-input-text-color);
	font: var(--h1);
	height: 56px;
	margin: 0;
	padding: 0;
	text-align: center;
	vertical-align: middle;

	&& {
		border-bottom-color: ${({ hasError }) =>
			hasError ? 'rgb(var(--input-border-error-color))' : 'rgb(var(--new-qd--amount-input-border-color))'};
		border-bottom-width: 1px;
	}

	&:focus {
		border-bottom-color: ${({ hasError }) =>
			hasError ? 'rgb(var(--input-border-error-color))' : 'rgb(var(--new-qd--amount-input-focus-border-color))'};
		color: var(--new-qd--amount-input-focus-text-color);
	}

	&:disabled {
		background-color: var(--new-qd--disabled-amount-input-bg);
		color: rgba(var(--new-qd--disabled-amount-input-text-color, var(--input-font-disabled-color)), 1);
	}
`;

export const SubTitle = styled(LabelRegular)`
	color: var(--new-qd--subtitle-text-color);
	width: 100%;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
`;

export const ActionButtonsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
